<div class="row filter-wrapper" *ngIf="filterArray.length">
  <div *ngFor="let filter of filterArray" class="col-lg-4 col-md-12 col-sm-12">
    <app-switch-checkbox
      bsClass="success"
      (change)="changeFilter(filter.value)"
    >
      {{ MigrationStateText[filter.value] }}
    </app-switch-checkbox>
  </div>
</div>
